/* unplugin-vue-components disabled */import script from "./alipayMiniGameDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./alipayMiniGameDetail.vue?vue&type=script&setup=true&lang=ts"

import "./alipayMiniGameDetail.vue?vue&type=style&index=0&id=bda6762c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bda6762c"]])

export default __exports__